module.exports = __webpack_public_path__ + "img/giovanni.001a0db6.png";